<template>
  <div class="relative flex flex-col gap-2">
    <TransitionGroup name="banner-slide">
      <div v-for="item in errors" :key="item.id" class="notification">
        <BaseSymbol name="status_error" />
        <div>{{ item.message }}</div>
        <button
          class="notification_close-btn"
          type="button"
          @click.stop="closeNotification(item.id)">
          <BaseIcon name="close" />
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useUiStore } from "@/stores/ui";
import BaseSymbol from "@emcd-shared/base-symbol";
import BaseIcon from "@emcd-shared/base-icon";
const uiStore = useUiStore();

const errors = computed(() => uiStore.errors);

const closeNotification = (id) => {
  uiStore.errors = uiStore.errors.filter((item) => item.id !== id);
};
</script>
